export default __webpack_public_path__ + "static/media/stage-4-mesocortex-thalamus.32f885a7.png";